module.exports = __webpack_public_path__ + "static/media/training.08eeb491.svg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/assets/images/training.svg
// module id = 1850
// module chunks = 27